import React from 'react';
import { AssignmentDisplayData } from 'types/assignment';
import { DetailsSingleDatum } from './detailsSingleDatum';

type Props = Pick<AssignmentDisplayData, 'activity'>;

export const ActivityData: React.FC<Props> = ({
  activity: { attivitaNr, attivitaTitolo, attivitaDescrizione, noteIntervento }
}) => (
  <div className="row no-gutters">
    <DetailsSingleDatum value={`${attivitaNr} - ${attivitaTitolo}`} boldValue />
    <DetailsSingleDatum value={attivitaDescrizione} />
    <DetailsSingleDatum title="note" value={noteIntervento} />
  </div>
);
